import { render, staticRenderFns } from "./HistoriasClinicas.vue?vue&type=template&id=9735dd4a&scoped=true"
import script from "./HistoriasClinicas.vue?vue&type=script&lang=js"
export * from "./HistoriasClinicas.vue?vue&type=script&lang=js"
import style0 from "./HistoriasClinicas.vue?vue&type=style&index=0&id=9735dd4a&prod&scoped=true&lang=css"
import style1 from "./HistoriasClinicas.vue?vue&type=style&index=1&id=9735dd4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9735dd4a",
  null
  
)

export default component.exports